
import { Vue, Component } from "vue-property-decorator";
import { BTabs, BTab } from "bootstrap-vue";

@Component({
  components: {
    "b-tabs": BTabs,
    "b-tab": BTab,
  },
})
export class UserTabs extends Vue {
  get userGridShowItems(): string {
    return this.$t("users.tab.title.users") as string;
  }

  get groupGridShowItems(): string {
    return this.$t("users.tab.title.groups") as string;
  }
}
export default UserTabs;
